'use strict';

var keyMirror = require('react/lib/keyMirror');

module.exports = keyMirror({
  STAMP: null,
  STAMP_REVIEW: null,
  ZINE: null,
  ZINE_EDIT: null,
  DRAFT_COMPOSE: null,
  DRAFT_PREVIEW: null,
  USER: null,
  IMAGE: null,
  DRAFT_FEEDBACK: null
});


/** WEBPACK FOOTER **
 ** ./constants/PageControlsTypes.js
 **/